import { render } from "./SelectEditInput.vue?vue&type=template&id=b9dba508"
import script from "./SelectEditInput.vue?vue&type=script&lang=js"
export * from "./SelectEditInput.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\user\\Documents\\coreme\\suporte\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__